import type { ReactElement, ReactNode } from 'react';
import SectionPages from './shell/SectionPages';

/**
 * The header both pages of My Approvals open with (Approvals at /approvals, Probation
 * Confirmation at /approvals/probation-confirmation): the title "My Approvals", the open
 * page's own line under it, then the section's pages as tabs, the open one the white
 * pill. The tabs are the pages this person holds, as the menu has them (DashboardLayout
 * hands them over); none for someone who holds only one. A fragment, so each page's own
 * spacing (space-y-6) sets the gaps.
 */
export default function MyApprovalsHeader({ subtitle }: { subtitle: ReactNode }): ReactElement {
  return (
    <>
      <div className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">My Approvals</h1>
          <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
        </div>
      </div>
      <SectionPages />
    </>
  );
}
